<template>
  <viewer
    ref="viewer"
    class="viewer"
    :options="options"
    :images="images"
  >
    <template scope="scope">
      <template v-for="src in scope.images">
        <img alt="" :key="src" v-show="false" :src="getOssPath(src)">
      </template>
      <file-editor :image="image" v-model="editor"></file-editor>
    </template>
  </viewer>
</template>

<script>
  import { mapState } from 'vuex'
  import file from '../../mixins/file'
  import Viewer from "v-viewer/src/component.vue"
  import 'viewerjs/dist/viewer.css'
  import FileEditor from '@views/components/FileEditor'

  export default {
    name: 'file-preview',
    mixins: [file],
    components: {FileEditor, Viewer},
    data: () => ({
      image: null,
      editor: false,
      random: Math.random()
    }),
    computed: {
      ...mapState({
        previewFiles: state => state.previewFiles
      }),
      images () {
        return this.previewFiles.map(file => {
          return file + '?v=' + this.random
        })
      },
      options () {
        return {
          title: false,
          view: this.viewImage,
          toolbar: {
            zoomIn: 4,
            zoomOut: 4,
            oneToOne: 4,
            reset: 4,
            prev: 4,
            next: 4,
            rotateLeft: 4,
            rotateRight: 4,
            flipHorizontal: 4,
            flipVertical: 4,
            settings: {
              show: true,
              click: this.editImage
            }
          }
        }
      }
    },
    watch: {
      previewFiles (previewFiles) {
        if (previewFiles.length > 0) {
          this.$refs['viewer'].$viewer.show()
        }
      },
      editor () {
        this.random = Math.random()
      }
    },
    methods: {
      viewImage (e) {
        if (!this.editor) {
          console.log(_.get(e, 'detail.index'))
          this.image = _.get(this.previewFiles, _.get(e, 'detail.index'))
        }
      },
      editImage () {
        this.editor = true
      }
    }
  }
</script>
